import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { SystemConfigView } from './views/SystemConfigView';

export const systemConfigRoutes: RouteObject[] = [
    {
        path: '/admin/system-config',
        element: <SystemConfigView />,
        errorElement: <ErrorBoundary />,
    },
];
